import * as ActionTypes from '../constants/ActionTypes';
import { browserHistory } from 'react-router';

import StoreService from '../services/StoreService';

const storeService = new StoreService();

export function start(nextURL) {
    return dispatch => {
        dispatch({ type: ActionTypes.START });
        if (nextURL) {
            browserHistory.push(nextURL);
        }
    };
}

export function updatePersonAttribute(attributeName, value) {
    return { type: ActionTypes.UPDATE_PERSON_ATTRIBUTE, attributeName, value };
}

export function createMessage() {
    return { type: ActionTypes.CREATE_MESSAGE };
}

export function submit(params, nextURL) {
    return dispatch => {
        storeService.postQuoteRequest(params).then(() => {
            dispatch({ type: ActionTypes.SUBMIT_SUCCESS });

            if (nextURL) {
                browserHistory.push(nextURL);
            }
        }).catch(error => {
            dispatch({ type: ActionTypes.SUBMIT_ERROR, error });
        });
    };
}

export function signUpToNewsletter(params) {
    return dispatch => {
        storeService.postNewsletter(params).then(() => {
            dispatch({ type: ActionTypes.SUBMIT_NEWSLETTER_SUCCESS });
        }).catch(error => {
            dispatch({ type: ActionTypes.SUBMIT_ERROR, error });
        });
    };
}

export function initialiseUrlQueryData(query) {
    return { type: ActionTypes.INITIALISE_URL_QUERY_DATA, query };
}



// WEBPACK FOOTER //
// ./src/actions/defaultActions.js